module.exports = __webpack_public_path__ + "img/1.f0f3d390.jpg";